import { createApp } from 'vue';
import { createRouter, createWebHashHistory } from 'vue-router';
import VueApexCharts from 'vue3-apexcharts';
import { createBootstrap } from 'bootstrap-vue-next';
import L from 'leaflet';
import bvModalShim from './modules/bvModalShim';
import bootstrapVueNextGlobals from './modules/bootstrapVueNextGlobals';
import 'flag-icons/css/flag-icons.css';
// No prebuilt 'bootstrap/dist/css/bootstrap.css' here: app.scss compiles the
// full bootstrap from SCSS with our theme ($primary etc.). Importing both
// ships bootstrap twice and leaves the stock palette in the cascade.
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';

import './app.scss';

import App from './App.vue';
import Report from './components/visualizer/Report.vue';
import Deliverable from './components/visualizer/Deliverable.vue';

// Vite/ESM-friendly icon URLs (replaces vue-cli's `require(...)`).
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl, iconUrl, shadowUrl });

const routes = [
  { name: 'report', path: '/visualizer/:taskId', component: Report },
  { name: 'diff', path: '/diff/:taskId1/:taskId2', component: Report },
  {
    name: 'deliverable',
    path: '/visualizer/deliverable/:deliverableId',
    component: Deliverable,
  },
];
const router = createRouter({ history: createWebHashHistory(), routes });

// Mount App.vue as the root component directly (NOT wrapped in an anonymous
// render-fn root). The wrapper pattern hides App.vue's `$refs.navbar` behind
// the wrapper's empty `$refs`, breaking the `window.app.$refs.navbar.filename`
// access used by Report.vue / FileMetadata.vue. With App as root,
// `app.mount()` returns App's instance proxy and its template-level
// `ref="navbar"` is reachable. See main.all.js for the same pattern.
const app = createApp(App);

app.use(router);
app.use(createBootstrap());
app.use(bootstrapVueNextGlobals); // re-create Vue 2 BootstrapVue global registration
app.use(bvModalShim); // must come after createBootstrap (injects controller)
app.use(VueApexCharts);

window.app = app.mount('#app');
